export function Logo() {
  return (
    <div className="flex items-center justify-center py-2">
      <img
        src="/logo-hit.webp"
        alt="HIT — High Impact Trainer"
        width="180"
        height="60"
        className="h-12 w-auto"
      />
    </div>
  );
}
